const MODEL_NAME = 'sweety'

export default [
  {
    path: `/${MODEL_NAME}/blinkbox-assemble`,
    name: 'sweetyBlinkboxAssemble',
    component: () =>
      import(/* webpackChunkName: "sweety-blinkbox-assemble" */ '@pages/activty/sign-in/bill.vue')
  }
]
